<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {
    // 这个是全局设置element-ui样式的类名，类名在/common/theme/index.scss中通过变量注入
    document.body.className = 'default-theme.promote_index_a.promote_index_b.promote_index_c'
    // sessionStorage.setItem('hostName',document.location.hostname)
  },
  mounted() {

  },
  methods: {
    injectTCCC({ token, sdkAppId, userId, sdkUrl }) {
      const scriptDom = document.createElement('script')
      scriptDom.setAttribute('crossorigin', 'anonymous')
      scriptDom.dataset.token = token
      scriptDom.dataset.sdkAppId = sdkAppId
      scriptDom.dataset.userid = userId
      scriptDom.src = sdkUrl
      document.body.appendChild(scriptDom)
      scriptDom.addEventListener('load', () => {
        // ready事件必须监听，否则容易发生tccc不存在的错误，所有呼入呼出的逻辑必须在ready事件触发后才可以调用
        window.tccc.on('ready', () => {
          // 以下为Demo逻辑，非业务必须。业务代码主要实现都在这个部分
          const statusVal = window.tccc.Agent.getStatus()
          this.status = statusVal;
          this.seat = userId;
        })
        // 以下为Demo逻辑，非接入必须
        setInterval(() => {
          const statusVal = window.tccc.Agent.getStatus()
          this.status = statusVal;
          tccc.UI.hidefloatButton()
        }, 200)
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}

* {
  box-sizing: border-box
}

p {
  margin: 0;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #00b38680 !important;
}
.el-form-item__label {
  line-height: 1.2;
}
.screen-wrapper {
  .table-data-view {
    border-radius: 16px;
    height: 100%;
    background-color: #00112B;
    overflow-y: auto;
    position: relative;
  }
  .table-pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    .el-pagination {
      .el-input {
        color: #0C96E0;
        .el-input__inner {
          border: 1px solid #0c96e0 !important;
          background: #0a1a33 !important;
        }
      }
      .btn-prev,.btn-next,.number,.el-icon-more {
        color: #0C96E0;
        border: 1px solid #0c96e0 !important;
        background: #0a1a33 !important;
        &.active {
          background: #0c96e0 !important;
          border: 1px solid #0c96e0;
          color: #fff;
        }
      }

    }
  }
  .search-bar {
    .el-input__inner,.el-input-number__increase,.el-input-number__decrease {
      background: #032147;
      border: 1px solid #a6c6d9;
      color: #FFFFFF;
    }
    .el-range-input {
      background: #032147;
    }
    .el-range-separator {
      color: #ffffff;
    }
  }
  .el-button--text {
    color: #0c96e0 !important;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #00395d;
  }
}
.class-tag {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 5px;
  padding: 5px 10px;
  span {
    line-height: 1.2;
  }
}
.state-delta {
  width: 0;
  height: 0;
  border-top-width: 25px;
  border-top-style: solid;
  border-right: 25px solid transparent;
}
.state-delta-red {
  border-top-color: #e21a1a;
}
.state-delta-blue {
  border-top-color: #22b3ad;
}
.prepare-date-delta {
  position: absolute;
  left: 0;
  top: 0;
}
@import './common/scss/common.scss';
@import './common/scss/alibaba_iconfont_config.scss';
@import './common/theme/index.scss';
</style>




// WEBPACK FOOTER //
// src/App.vue